import colors from 'tailwindcss/colors';
import { ChartOptions } from 'chart.js';
import { toggleLegendIndexInLocalStorage } from '../utils';

const listStyles = `
    list-style: none;
    padding-left: 0;
`;
const nameStyle = `color: ${colors.blueGray[500]};`;
const fontFamily = 'Rubik,Arial,sans-serif';
const fontColor = colors.blueGray[800];

const tooltip = {
    mode: 'index' as const,
    // Показывать не только при наведении на конкретную точку
    intersect: false,
    // выкл дефолт тултип
    enabled: false,
    external(context: any): void { // eslint-disable-line
        const tooltipModel = context.tooltip;
        // Тултип
        let tooltipEl = document.getElementById('chartjs-tooltip');

        // Создаем на первый рендер
        if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.id = 'chartjs-tooltip';
            tooltipEl.innerHTML = `<ul style="${listStyles}"></ul>`;
            document.body.appendChild(tooltipEl);
        }

        // Здесь тултип пропадает
        if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = '0';
            return;
        }

        tooltipEl.classList.remove('above', 'below', 'no-transform');
        if (tooltipModel.yAlign) {
            tooltipEl.classList.add(tooltipModel.yAlign);
        } else {
            tooltipEl.classList.add('no-transform');
        }

        // Тут генерится контент
        if (tooltipModel.body) {
            // tooltipModel.title - массив заголовков ['значение']
            const [title] = tooltipModel.title || [];
            // Инфа по линиям графика состоит из [["название: значение"], ["название: значение"]]
            const linesInfo = tooltipModel.body.map(({ lines }) => lines);

            // [info] = "название: значение"
            const linesInfoRows = linesInfo.map(([info], i) => {
                // достанем цвет линии
                const { backgroundColor } = tooltipModel.labelColors[i];
                // Стили для кружочков в тултипе
                const circleStyle = `
                    width: 13px;
                    height: 13px;
                    border: 2px solid ${colors.white};
                    display: inline-block;
                    border-radius: 50%;
                    margin-bottom: -2px;
                    box-sizing: border-box;
                    background: ${backgroundColor};
                `;
                const circle = `<span style="${circleStyle}"></span>`;

                const [name, value] = info.split(': ');
                return `<li>
                            ${circle}
                            <span style="${nameStyle}">${name}</span>
                            ${value}
                        </li>`;
            });

            const tooltipContent = `
                    <li>${title}</li>
                    ${linesInfoRows.join('')}
            `;

            const list = tooltipEl.querySelector('ul');
            list.innerHTML = tooltipContent;
        }

        const position = context.chart.canvas.getBoundingClientRect();

        let leftValue = position.left + window.pageXOffset + tooltipModel.caretX;
        const topValue = position.top + window.pageYOffset + tooltipModel.caretY;
        const screenHalfWidth = document.documentElement.offsetWidth / 2;
        // Нужно, чтобы тултип не уходил за экран
        if (leftValue > screenHalfWidth) leftValue -= 173;

        // Display, position, and set styles for font
        tooltipEl.style.opacity = '1';
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.left = `${leftValue}px`;
        tooltipEl.style.top = `${topValue}px`;
        tooltipEl.style.padding = '8px 12px';
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.backgroundColor = colors.white;
        tooltipEl.style.fontSize = '12px';
        tooltipEl.style.boxShadow = '0px 2px 10px rgba(8, 26, 45, 0.15)';
        tooltipEl.style.borderRadius = '1px';
        tooltipEl.style.lineHeight = '1.5';
    },
};

const legend = {
    position: 'bottom' as const,
    labels: {
        padding: 22,
        usePointStyle: true,
        boxWidth: 6,
        font: {
            family: fontFamily,
        },
        color: colors.blueGray[500],
        pointStyle: 'circle' as const,
    },
    onClick: toggleLegendIndexInLocalStorage,
};

const scales = {
    y: {
        ticks: {
            padding: 10,
            color: fontColor,
            font: {
                family: fontFamily,
            },
        },
        grid: {
            // Пунктир линии
            borderDash: [2, 4],
            tickMarkLength: 20,
            color: colors.blueGray[200],
        },
    },
    x: {
        ticks: {
            // TODO: нужен ли тут паддинг?
            padding: 20,
            color: fontColor,
            font: {
                family: fontFamily,
            },
        },
        grid: {
            color: colors.blueGray[200],
        },
    },
    revenue: {
        grid: {
            drawTicks: false,
            tickBorderDashOffset: 1,
            // немного хак, скрыть сетку
            borderDash: [0, 1],
            color: colors.blueGray[200],
        },
        position: 'right' as const,
        ticks: {
            padding: 10,
            color: fontColor,
            font: {
                family: fontFamily,
            },
        },
    },
};

const options: ChartOptions<'bar'> = {
    // сохранение соотношений сторон графика(выкл)
    maintainAspectRatio: false,
    animation: {
        duration: 0,
        // resize: { duration: 0 },
    },
    font: {
        family: fontFamily,
    },
    hover: {
        // Выделять все кружочки при наведении
        // animationDuration: 0,
        intersect: false,
    },
    scales,
    plugins: {
        tooltip,
        legend,
    },
};

export default {
    type: 'bar' as const,
    data: {
        labels: [],
        datasets: [],
    },
    options,
};
